module.exports = __webpack_public_path__ + "img/book2.fb2c09b3.png";